const EMAIL_SLUGS = new Set(['other_email', 'other-email']);
const WHATSAPP_SLUGS = new Set(['whatsapp', 'whatsapp-business']);

function integrationRows(list) {
  if (Array.isArray(list)) return list;
  if (Array.isArray(list?.results)) return list.results;
  return [];
}

/** Connected only when the company integration row says is_connected. */
export function messagingChannelsFromIntegrations(list) {
  const channels = { email: false, whatsapp: false, instagram: false };
  for (const item of integrationRows(list)) {
    if (item?.is_connected !== true) continue;
    const slug = item.integration_slug || item.slug;
    if (EMAIL_SLUGS.has(slug)) channels.email = true;
    else if (WHATSAPP_SLUGS.has(slug)) channels.whatsapp = true;
    else if (slug === 'instagram') channels.instagram = true;
  }
  return channels;
}

const PENDING_WHATSAPP = new Set([
  'pending',
  'activating',
  'in_progress',
  'processing',
]);

/** connected | pending | disconnected. HTTP failures stay outside this. */
export function classifyWhatsAppStatus(data) {
  if (!data || typeof data !== 'object') return 'disconnected';
  const status = String(data.status || '').toLowerCase();
  if (
    data.is_connected === true ||
    status === 'activated' ||
    status === 'completed'
  ) {
    return 'connected';
  }
  if (PENDING_WHATSAPP.has(status)) return 'pending';
  return 'disconnected';
}

export function isMessagingChannelOpen(channels, channel) {
  if (channel === 'email') return channels?.email === true;
  if (channel === 'whatsapp') return channels?.whatsapp === true;
  return false;
}
